import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BeepCallsCrudLayer from "../components/BeepCallsCrudLayer";

const BeepCallsPage = () => {
  return (
    <>
      <MasterLayout>
        <BeepCallsCrudLayer />
      </MasterLayout>
    </>
  );
};

export default BeepCallsPage;
